export const headers = [
  { name: 'Promotor', field: 'promoter.name', sortable: true },
  { name: 'Rota', field: 'name', sortable: true },
  { name: 'Data', field: 'scheduled_date', sortable: true, custom: true },
  { name: 'Prioridade', field: 'priority', sortable: true, custom: true },
  { name: 'Status', field: 'status', sortable: true, custom: true },
  { name: 'Ações', field: 'actions', sortable: false }
]
